import { Action } from '@ngrx/store';

export enum CandidateFormActionTypes {
  SelectCandidateFormId = '[Candidate Form] Select id'
}

export class CandidateFormIdSelect implements Action {
  readonly type = CandidateFormActionTypes.SelectCandidateFormId;

  constructor(public payload?: number) {}
}

export type CandidateFormActionsUnion = CandidateFormIdSelect;
